import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_bank_list = createAsyncThunk("bank", async (data) => {
  console.log(data,"dashhdgsa")
  const body = new FormData();
  body.append("action", "list");
  body.append("page", data.page.toString());
  body.append("limit", data.rows.toString());
  const response = await fetch(baseUrl + "bank.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log("banks", res);
  return res;
});

export const update_bank_status = createAsyncThunk(
  "banks/updateBankStatus",
  async (id, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("action", "update_default_status");
      formData.append("id", id);

      const response = await fetch(baseUrl + "bank.php", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        return rejectWithValue(data.message || "Failed to update status");
      }

      return data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

const initialState = {
  bank_list: [],
  total_bank_count: 0,
  loading: false,
  update_status_loading: false,
};

const bankSlice = createSlice({
  name: "banks",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(get_bank_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_bank_list.rejected, (state) => {
        state.loading = false;
      })
      .addCase(get_bank_list.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload;
        if (data.success) {
          console.log(data,"dsadfsgdfsgh")
          state.bank_list = data.data;
          state.total_bank_count = parseInt(data.totalcount) || 0;
        } else {
          state.bank_list = [];
          state.total_bank_count = 0;
        }
      })
      .addCase(update_bank_status.pending, (state) => {
        state.update_status_loading = true;
      })
      .addCase(update_bank_status.fulfilled, (state) => {
        state.update_status_loading = false;
      })
      .addCase(update_bank_status.rejected, (state) => {
        state.update_status_loading = false;
      });
  },
});

export default bankSlice.reducer;
